import tmhRequest from '@/config/tmhRequest'

export default {
    searchMemberAnalysisReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportcount',
            method: 'post',
            data: data,
        })
    },
    searchMemberAnalysisReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/searchmemberanalysisreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportMemberAnalysisReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberanalysisreport/exportmemberanalysisreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/memberanalysisreport.js